import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Exchange Rate',
    rate: '1 {nativeToken} = {value} {token}',
  },
};
